import AppHeaderMenu from './AppHeaderMenu';
import AppContent from './AppContent';
import { Typography } from '@material-ui/core';
import CookiesProvider from './hooks/CookiesProvider';
import AnimeProvider from './hooks/AnimeProvider';

function App() {  
  return (
    <>
      <CookiesProvider>
        <AnimeProvider>
          <AppHeaderMenu />
          <AppContent />
          <Typography className="appFooter" variant="body2">© 2025 Joanne Chen. All rights reserved.</Typography>
        </AnimeProvider>
      </CookiesProvider>
    </>
  );
}

export default App;
